<div class="button-field">
  <dx-button
    [text]="text"
    icon= "fa-regular fa-file"
    [type]="type"
    stylingMode="contained"
    [elementAttr]="{ class: 'generate-button' }"
    (onClick)="handleClick()"
  ></dx-button>
</div>
